export default __webpack_public_path__ + "static/media/prize-3-cn.52077b08.webp";